(function() {
    /**
        Decide whether the response interceptor should trigger a refresh.
        Pure function — extracted so it can be unit-tested without Angular bootstrap.

        @param {string|undefined} currentHash    cached hash on $rootScope.user
        @param {string|undefined} newHash        X-User-Permissions-Hash from response
        @returns {boolean}
     **/
    function shouldRefresh(currentHash, newHash) {
        if (newHash && currentHash && newHash !== currentHash) {
            return true
        }
        // Cold start (either side falsy) → silent adopt via setUser, no refresh
        return false
    }

    if (typeof module !== "undefined" && module.exports) {
        module.exports = { shouldRefresh: shouldRefresh }
    }

    // Guard angular registration so the file can be require()d in Jest+jsdom
    // for pure-function unit tests without bootstrapping Angular.
    if (typeof angular === "undefined") return

    angular
        .module("app")
        .factory("requestService", requestService)

    requestService.$inject = [
        "$rootScope",
        "$q",
        "$injector"
    ]

    /**
        @param $rootScope
        @param $q
        @param $injector
        @returns {{request: request, requestError: requestError, response: response, responseError: responseError}}
     **/
    function requestService(
        $rootScope,
        $q,
        $injector
    ) {
        return {
            // On request
            request: function(config) {
                config.headers["X-User-Username"] = $rootScope.user.username
                config.headers["X-User-Token"] = $rootScope.user.authentication_token

                config.withCredentials = true

                return config || $q.when(config)
            },

            // On request failure
            requestError: function(rejection) {
                // console.error(rejection)

                return $q.reject(rejection)
            },

            // On response success
            response: function(response) {
                if ($rootScope.user && $rootScope.is_authenticated && response && response.headers) {
                    var newHash = response.headers("X-User-Permissions-Hash")
                    var currentHash = $rootScope.user.permissions_state_hash

                    if (shouldRefresh(currentHash, newHash)) {
                        $injector.get("authenticationService")
                            .refreshScopedPermissionsIfNeeded(newHash)
                    }
                }

                return response || $q.when(response)

            },

            // On response failure
            responseError: function(rejection) {

                const userMessagingService = $injector.get("userMessagingService")

                if(rejection.status == 401) {
                    $injector.get("authenticationService").logout(() => {
                        userMessagingService.error("The Username/Password combination you provided was incorrect or your session has expired. Please try logging in again.")
                    })
                }

                if(rejection.status == 403) {
                    $injector.get("$state").go("devices").then(() => {
                        userMessagingService.error("You are not authorized to perform that action.")
                    })
                }

                return $q.reject(rejection)

            }
        }
    }
})()
